"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSimpleProductCard = _interopRequireDefault(require("./styled-simple-product-card"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var useEffect = _react["default"].useEffect,
  useRef = _react["default"].useRef;
var propTypes = {};
var defaultProps = {};
var animatedGradient = (0, _styledComponents.css)(["background:linear-gradient( -45deg,var(--color-global-grey400),var(--color-global-grey300),var(--color-global-grey400),var(--color-global-grey500) );background-size:400% 400%;animation:gradient 4s ease infinite;@keyframes gradient{0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}}"]);
var SkeletonImg = _styledComponents["default"].div.attrs({
  className: 'simple-product-card__skeleton-image'
}).withConfig({
  displayName: "simple-skeleton-card__SkeletonImg",
  componentId: "sc-1j9rdt0-0"
})(["width:100%;aspect-ratio:3 /4;margin:0 0 var(--spacing-global-space4);", ""], animatedGradient);
var SkeletonBrand = _styledComponents["default"].div.attrs({
  className: 'simple-product-card__skeleton-brand'
}).withConfig({
  displayName: "simple-skeleton-card__SkeletonBrand",
  componentId: "sc-1j9rdt0-1"
})(["width:30%;height:var(--font-line-height-m1);", " margin:0 0 var(--spacing-global-space2);"], animatedGradient);
var SkeletonTitle = _styledComponents["default"].div.attrs({
  className: 'simple-product-card__skeleton-title'
}).withConfig({
  displayName: "simple-skeleton-card__SkeletonTitle",
  componentId: "sc-1j9rdt0-2"
})(["margin:0 0 var(--spacing-global-space3);&::before,&::after{content:'';display:block;height:var(--font-line-height-m1);", "}&:before{margin:0 0 1px;width:100%;}&:after{width:40%;}"], animatedGradient);
var SkeletonPrice = _styledComponents["default"].div.attrs({
  className: 'simple-product-card__skeleton-price'
}).withConfig({
  displayName: "simple-skeleton-card__SkeletonPrice",
  componentId: "sc-1j9rdt0-3"
})(["height:var(--spacing-global-space7);margin-bottom:var(--spacing-global-space4);width:30%;", ""], animatedGradient);
var SkeletonPrevPrice = _styledComponents["default"].div.attrs({
  className: 'simple-product-card__skeleton-previous-price'
}).withConfig({
  displayName: "simple-skeleton-card__SkeletonPrevPrice",
  componentId: "sc-1j9rdt0-4"
})(["height:var(--spacing-global-space6);width:30%;", " margin-bottom:var(--spacing-global-space5);"], animatedGradient);
function SkeletonCardComponent(props) {
  var skeletonImgRef = useRef();
  useEffect(function () {
    var isSafari = (0, _fuseUtils.isSafariV14OrBelow)();

    // At first render, if safari browser version 14 or below is detected set aspect ratio of image due to CSS aspect-ratio not being supported
    if (isSafari) (0, _fuseUtils.setAspectRatio)(skeletonImgRef.current, 'height', 3 / 4);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledSimpleProductCard["default"], _extends({}, props, {
    as: "div",
    className: "fuse-product-card fuse-product-card--skeleton",
    "data-testid": "product-card-skeleton"
  }), /*#__PURE__*/_react["default"].createElement(SkeletonImg, {
    "data-testid": "product-card-skeleton__image",
    ref: skeletonImgRef
  }), /*#__PURE__*/_react["default"].createElement(SkeletonBrand, {
    "data-testid": "product-card-skeleton__price"
  }), /*#__PURE__*/_react["default"].createElement(SkeletonTitle, {
    "data-testid": "product-card-skeleton__title"
  }), /*#__PURE__*/_react["default"].createElement(SkeletonPrice, {
    "data-testid": "product-card-skeleton__price",
    className: "fuse-product-card__price"
  }), /*#__PURE__*/_react["default"].createElement(SkeletonPrevPrice, {
    "data-testid": "product-card-skeleton__prev-price",
    className: "fuse-product-card__prev-price"
  }));
}
SkeletonCardComponent.propTypes = propTypes;
SkeletonCardComponent.defaultProps = defaultProps;
var _default = exports["default"] = SkeletonCardComponent;